import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CodeBlocksContainer from './CodeBlocksContainer'
import groupByBA from './groupByBA'
import CodeDragger from './CodeDragger'
import DropZone from 'Components/DropZone'
import classNames from 'classnames'
import {
  INVENTORY_MOVEMENT_OUT,
  INVENTORY_MOVEMENT_IN,
} from '../../../../../shared/constants'

export class FlyerCodesGiveOutWidgetUnstyled extends PureComponent {
  static propTypes = {
    updateLocalInventoryState: PropTypes.func,
    /**
     * When a code is to be returned from a BA back to inventory, not the same
     * as leftovers.
     * @param {string} code
     */
    onReturnCode: PropTypes.func,
    /**
     * Codes that are available to select
     */
    availableCodes: PropTypes.arrayOf({
      code: PropTypes.string,
      /**
       * The total flyers we have of this code
       */
      quantity: PropTypes.number,
    }),
    /**
     * Codes that have been given out
     */
    givenOutCodes: PropTypes.arrayOf({
      code: PropTypes.string,
      /**
       * Should be the id of the brand ambassador
       */
      ambassadorId: PropTypes.string,
      /**
       * The total flyers we have of this code
       */
      quantity: PropTypes.number,
    }),
    ambassadors: PropTypes.arrayOf({
      /**
       * The brand ambassador id
       */
      id: PropTypes.string,
      /**
       * The brand ambassador name
       */
      name: PropTypes.string,
    }),
  }

  constructor(props) {
    super(props)
    this.state = {
      codeInAction: null,
    }
  }
  componentDidMount = () => {
    document.addEventListener('mouseup', this.onMouseUp)
    document.addEventListener('touchup', this.onMouseUp)
  }

  componentWillUnmount = () => {
    document.removeEventListener('mouseup', this.onMouseUp)
    document.removeEventListener('touchup', this.onMouseUp)
  }

  onMouseUp = () => this.setState({ codeInAction: null })

  onCityInventoryCodeGrab = code => {
    this.setState({ codeInAction: code })
  }

  onBAInventoryCodeGrab = (baId, code) => {
    //console.log('onBAInventoryCodeGrab', baId, code)
    this.setState({ codeInAction: code })
  }

  onBAInventoryCodeDrop = (baId, code) => {
    var { availableCodes, givenOutCodes } = this.props
    givenOutCodes = givenOutCodes.slice(0)
    if (code.ambassadorId) {
      // Remove it from another ambassador
      var index = givenOutCodes.findIndex(
        c =>
          c.ambassadorId == code.ambassadorId &&
          c.inventoryId == code.inventoryId,
      )
      givenOutCodes.splice(index, 1)
    } else {
      // Remove it from city stock
      var index = availableCodes.findIndex(
        c => c.inventoryId == code.inventoryId,
      )
      availableCodes = availableCodes.slice(0)
      availableCodes.splice(index, 1)
    }
    const updatedCode = {
      ...code,
      ambassadorId: baId,
      previousAmbassadorId: code.ambassadorId,
    }
    // Add it to the BA
    givenOutCodes.push(updatedCode)

    this.props.updateLocalInventoryState({
      type: INVENTORY_MOVEMENT_OUT,
      code: updatedCode,
      inventoryType: this.props.inventoryType,
    })

    this.setState({ codeInAction: null, givenOutCodes, availableCodes })
    this.props.onGiveInventoryToBA(baId, code)
  }

  onReturnInventoryCodeDrop = (baId, code) => {
    // Code was dropped from this box so don't do anything
    if (!baId) return
    var { availableCodes, givenOutCodes } = this.props
    givenOutCodes = givenOutCodes.slice(0)
    var index = givenOutCodes.findIndex(
      c =>
        c.ambassadorId == code.ambassadorId &&
        c.inventoryId == code.inventoryId,
    )
    givenOutCodes.splice(index, 1)
    // Add it to the current stock
    const updatedCode = {
      ...code,
      ambassadorId: null,
      previousAmbassadorId: code.ambassadorId,
    }
    availableCodes.push(updatedCode)

    this.props.updateLocalInventoryState({
      type: INVENTORY_MOVEMENT_IN,
      code: updatedCode,
      inventoryType: this.props.inventoryType,
    })
    this.setState({ codeInAction: null, givenOutCodes, availableCodes })
    this.props.onReturnCode(baId, code)
  }

  render = () => {
    var {
      className,
      ambassadors,
      totalAvailableCodes,
      totalGivenOutCodes,
    } = this.props
    const { availableCodes, givenOutCodes } = this.props

    const { codeInAction } = this.state

    /**
     * Filters out the codeInAction
     */
    const codeInActionFilterFunction = codeObj => {
      if (!codeInAction) return true
      return codeObj !== codeInAction
    }

    return (
      <div className={className}>
        <div className="AvailableCodesContainer">
          <div className="header">City Inventory</div>
          <div className="content">
            <DropZone
              onDrop={
                codeInAction
                  ? this.onReturnInventoryCodeDrop.bind(
                      this,
                      codeInAction.ambassadorId,
                      codeInAction,
                    )
                  : null
              }
              className={classNames({
                'BADropZone': !!codeInAction,
                'BADropZoneNotActive': !codeInAction,
              })}
            >
              <CodeBlocksContainer
                codes={availableCodes.filter(codeInActionFilterFunction)}
                totalCodes={
                  totalAvailableCodes ||
                  (availableCodes.length > 25
                    ? availableCodes.length
                    : undefined)
                }
                onCodeGrab={this.onCityInventoryCodeGrab}
              />
            </DropZone>
          </div>
        </div>
        <div className="GiveOutContainer">
          <div className="header">BA Inventory</div>
          <div className="content">
            {groupByBA(
              givenOutCodes.filter(codeInActionFilterFunction),
              ambassadors,
              true,
            ).map(baGroup => {
              return (
                <DropZone
                  onDrop={
                    codeInAction
                      ? this.onBAInventoryCodeDrop.bind(
                          this,
                          baGroup.id,
                          codeInAction,
                        )
                      : null
                  }
                  className={classNames({
                    'BADropZone': !!codeInAction,
                    'BADropZoneNotActive': !codeInAction,
                  })}
                >
                  <h3
                    className={baGroup.flag ? 'flaggedBa' : null}
                    title={baGroup.title}
                  >
                    {baGroup.name}
                  </h3>
                  <CodeBlocksContainer
                    codes={baGroup.codes}
                    onCodeGrab={this.onBAInventoryCodeGrab.bind(
                      this,
                      baGroup.id,
                    )}
                    totalCodes={
                      totalGivenOutCodes ||
                      (baGroup.codes.length > 25
                        ? baGroup.codes.length
                        : undefined)
                    }
                  />
                </DropZone>
              )
            })}
          </div>
        </div>

        {codeInAction ? <CodeDragger code={codeInAction} /> : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/FlyerCodesGiveOutWidget/unstyled.js